var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_237_4142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2463 25.8909L5.85884 11.8918C5.6207 11.273 5.63814 10.5849 5.9073 9.97898C6.17647 9.37303 6.67533 8.89883 7.29412 8.66069L19.8933 3.81199L27.0766 22.4775L14.4774 27.3262C13.8586 27.5643 13.1705 27.5469 12.5646 27.2777C11.9586 27.0086 11.4844 26.5097 11.2463 25.8909ZM11.2463 25.8909C11.0081 25.2721 11.0256 24.584 11.2947 23.9781C11.5639 23.3722 12.0628 22.898 12.6816 22.6598L25.2808 17.8111",
    stroke: "#787777",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3199 14.7625L14.9048 15.9108L17.2012 10.741",
    stroke: "#787777",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_237_4142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.507812 9.12891) rotate(-21.0488)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookCheck);
export default __webpack_public_path__ + "static/media/book-check.d053614d7974397300c9ec05a74bda94.svg";
export { ForwardRef as ReactComponent };